module.exports = __webpack_public_path__ + "static/media/second.bc701191.png";